// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4812) return "static/chunks/4812-c18d5cb0fe9b2acd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3841":"e60814902e996807","5283":"ed3731ef00b5d90f","5803":"9745cbf46c895473","6222":"1d52f41559ae583d","8603":"cbfc5608abc686f3"}[chunkId] + ".js";
};